/**
 * Utilitaire pour mélanger les réponses tout en gardant la correspondance avec l'index original
 */

export interface ShuffledAnswer {
  text: string;
  originalIndex: number; // Index original (0-based) dans le tableau des réponses
}

/**
 * Mélange un tableau d'options et retourne un tableau avec les options mélangées
 * et leur index original
 * @param options - Tableau des options de réponse
 * @returns Tableau d'objets avec le texte de la réponse et son index original
 */
export const shuffleAnswers = (options: string[]): ShuffledAnswer[] => {
  // Créer un tableau avec les textes et leurs indices originaux
  const indexedOptions: ShuffledAnswer[] = options.map((text, index) => ({
    text,
    originalIndex: index
  }));

  // Mélanger le tableau en utilisant l'algorithme Fisher-Yates
  for (let i = indexedOptions.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [indexedOptions[i], indexedOptions[j]] = [indexedOptions[j], indexedOptions[i]];
  }

  return indexedOptions;
};

/**
 * Trouve l'index original d'une réponse dans le tableau mélangé
 * @param shuffledAnswers - Tableau des réponses mélangées
 * @param selectedAnswer - Texte de la réponse sélectionnée
 * @returns L'index original (0-based) de la réponse sélectionnée, ou -1 si non trouvé
 */
export const getOriginalIndex = (shuffledAnswers: ShuffledAnswer[], selectedAnswer: string): number => {
  const answer = shuffledAnswers.find(a => a.text === selectedAnswer);
  return answer ? answer.originalIndex : -1;
};
